import { z } from 'zod';

export const PT_LEADERBOARD_READER_PERMISSION = 'PT Leaderboard Reader';

export const PtLeaderboardDatePresetSchema = z.enum([
  '1d',
  '7d',
  '30d',
  'custom',
  'all',
]);

export const PtLeaderboardTransitionColumnSchema = z.enum([
  'confirmations',
  'releaseBlockerAndRetestSignal',
  'coPilotExploits',
  'findingsPublished',
  'markedDuplicate',
  'dismissals',
]);

export const PtLeaderboardQuerySchema = z.object({
  preset: PtLeaderboardDatePresetSchema.optional(),
  from: z.iso.datetime().optional(),
  to: z.iso.datetime().optional(),
  tenantId: z.string().optional(),
});

export const PtLeaderboardRowSchema = z.object({
  actorName: z.string(),
  confirmations: z.number(),
  releaseBlockerAndRetestSignal: z.number(),
  coPilotExploits: z.number(),
  findingsPublished: z.number(),
  markedDuplicate: z.number(),
  dismissals: z.number(),
  total: z.number(),
});

export const PtLeaderboardResponseSchema = z.object({
  rows: z.array(PtLeaderboardRowSchema),
  truncated: z.boolean(),
});

export type PtLeaderboardDatePreset = z.infer<
  typeof PtLeaderboardDatePresetSchema
>;
export type PtLeaderboardTransitionColumn = z.infer<
  typeof PtLeaderboardTransitionColumnSchema
>;
export type PtLeaderboardQuery = z.infer<typeof PtLeaderboardQuerySchema>;
export type PtLeaderboardRow = z.infer<typeof PtLeaderboardRowSchema>;
export type PtLeaderboardResponse = z.infer<typeof PtLeaderboardResponseSchema>;
